var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "shared-node"
  }, [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.formData,
      "label-col": {
        span: 24
      },
      "wrapper-col": {
        span: 24
      },
      rules: _vm.rules
    }
  }, _vm._l(_vm.editableArea, function (formItem, index) {
    return _c("div", {
      key: `current${index}`
    }, [formItem.formName ? _c("top-title", {
      key: index
    }, [_c("span", {
      attrs: {
        slot: "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.$t(formItem.formName)))])]) : _vm._e(), _vm._l(formItem.form, function (item2, controlIndex) {
      return _c("div", {
        key: controlIndex
      }, [item2.controlType === "control" && _vm.showControl[item2.control.mark] ? _c("div", [_c("a-form-model-item", {
        attrs: {
          prop: item2.control.mark
        }
      }, [item2.control.partsType !== "paragraph" && item2.control.partsType !== "sign" ? _c("div", [_c("span", {
        attrs: {
          slot: "label"
        },
        slot: "label"
      }, [_vm._v(" " + _vm._s(item2.control.controlName) + " "), _c("a-tooltip", [_c("template", {
        slot: "title"
      }, [_vm._v(" " + _vm._s(item2.control.controlExplain) + " ")]), item2.control.controlExplain ? _c("a-icon", {
        staticStyle: {
          margin: "0 3px"
        },
        attrs: {
          type: "question-circle"
        }
      }) : _vm._e()], 2)], 1)]) : _vm._e(), item2.control.partsType === "singleLine" ? [_c("div", [item2.control.prefix ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.control.prefix)))]) : _vm._e(), _c("el-input", {
        attrs: {
          placeholder: item2.control.promptText,
          disabled: !_vm.echoNodeIsEdit
        },
        model: {
          value: _vm.formData[item2.control.mark],
          callback: function ($$v) {
            _vm.$set(_vm.formData, item2.control.mark, $$v);
          },
          expression: "formData[item2.control.mark]"
        }
      }), item2.control.suffix ? _c("span", [_vm._v(_vm._s(_vm.$t(item2.control.suffix)))]) : _vm._e()], 1)] : item2.control.partsType === "multiline" ? [_c("el-input", {
        attrs: {
          type: "textarea",
          placeholder: item2.control.promptText,
          disabled: !_vm.echoNodeIsEdit
        },
        model: {
          value: _vm.formData[item2.control.mark],
          callback: function ($$v) {
            _vm.$set(_vm.formData, item2.control.mark, $$v);
          },
          expression: "formData[item2.control.mark]"
        }
      })] : item2.control.partsType === "singleChoice" ? [_c("singleChoice", {
        attrs: {
          controlData: item2.control,
          isEdit: _vm.echoNodeIsEdit,
          associationInfo: _vm.associationInfo,
          formData: _vm.formData
        },
        on: {
          showControl: _vm.changeControlShow
        }
      })] : item2.control.partsType === "multipleChoice" ? [_c("multipleChoice", {
        attrs: {
          isEdit: _vm.echoNodeIsEdit,
          controlData: item2.control,
          associationInfo: _vm.associationInfo,
          formData: _vm.formData
        },
        on: {
          showControl: _vm.changeControlShow
        }
      })] : item2.control.partsType === "date" ? [_c("dateControl", {
        attrs: {
          controlData: item2.control,
          formData: _vm.formData,
          isEdit: _vm.echoNodeIsEdit
        }
      })] : item2.control.partsType === "dropDown" ? [_c("drop-down-select", {
        attrs: {
          controlConfig: item2.control,
          bankData: _vm.bankData,
          isEdit: _vm.echoNodeIsEdit,
          countriesData: _vm.countriesData,
          logisticsData: _vm.logisticsData,
          provinceArea: _vm.provinceArea,
          associationInfo: _vm.associationInfo,
          provinceData: _vm.provinceData,
          provinceFirstLevel: _vm.provinceFirstLevel,
          formData: _vm.formData
        },
        on: {
          showControl: _vm.changeControlShow
        }
      })] : item2.control.partsType === "enclosure" ? [_c("enclosureModel", {
        attrs: {
          formDataArray: item2.control,
          isEdit: _vm.echoNodeIsEdit
        }
      })] : item2.control.partsType === "paragraph" ? [_c("paragraphModel", {
        attrs: {
          itemData: item2.control,
          isEdit: _vm.echoNodeIsEdit
        }
      })] : item2.control.partsType === "sign" ? [_c("signModel", {
        attrs: {
          itemData: item2.control,
          controlMark: _vm.formData[item2.control.mark],
          isEdit: _vm.echoNodeIsEdit
        },
        on: {
          "update:controlMark": function ($event) {
            return _vm.$set(_vm.formData, item2.control.mark, $event);
          },
          "update:control-mark": function ($event) {
            return _vm.$set(_vm.formData, item2.control.mark, $event);
          }
        }
      })] : _vm._e(), item2.control.partsType === "payment" ? [_c("div", {
        staticStyle: {
          display: "flex"
        }
      }, [_c("a-input", {
        style: {
          width: item2.control.widthSet
        },
        attrs: {
          placeholder: item2.control.promptText,
          disabled: !_vm.echoNodeIsEdit
        },
        model: {
          value: _vm.formData[item2.control.mark],
          callback: function ($$v) {
            _vm.$set(_vm.formData, item2.control.mark, $$v);
          },
          expression: "formData[item2.control.mark]"
        }
      }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e(), item2.control.partsType === "estimate" ? [_c("div", {
        staticStyle: {
          display: "flex"
        }
      }, [_c("a-input", {
        style: {
          width: item2.control.widthSet
        },
        attrs: {
          placeholder: item2.control.promptText,
          disabled: !_vm.echoNodeIsEdit
        },
        model: {
          value: _vm.formData[item2.control.mark],
          callback: function ($$v) {
            _vm.$set(_vm.formData, item2.control.mark, $$v);
          },
          expression: "formData[item2.control.mark]"
        }
      }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e(), item2.control.partsType === "table" ? [_c("table-control", {
        ref: `table${item2.control.mark}`,
        refInFor: true,
        attrs: {
          controlData: item2.control,
          isEdit: _vm.echoNodeIsEdit
        }
      })] : _vm._e()], 2)], 1) : item2.controlType === "controlGroup" && _vm.showControl[item2.mark] ? _c("div", [_c("h4", [_vm._v(_vm._s(item2.controlName))]), _vm._l(item2.control, function (subControl, subControlIndex) {
        return _c("div", {
          key: subControlIndex
        }, [_c("a-form-model-item", {
          attrs: {
            label: subControl.controlName,
            prop: subControl.mark
          }
        }, [subControl.controlExplain ? _c("span", {
          attrs: {
            slot: "label"
          },
          slot: "label"
        }, [_vm._v(" " + _vm._s(subControl.controlName) + " "), _c("a-tooltip", [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(subControl.controlExplain) + " ")]), _c("a-icon", {
          staticStyle: {
            margin: "0 3px"
          },
          attrs: {
            type: "question-circle"
          }
        })], 2)], 1) : _vm._e(), subControl.partsType === "singleLine" ? _c("div", [_c("div", [subControl.prefix ? _c("span", [_vm._v(_vm._s(_vm.$t(subControl.prefix)))]) : _vm._e(), _c("el-input", {
          attrs: {
            placeholder: subControl.promptText,
            disabled: !_vm.echoNodeIsEdit
          },
          model: {
            value: _vm.formData[subControl.mark],
            callback: function ($$v) {
              _vm.$set(_vm.formData, subControl.mark, $$v);
            },
            expression: "formData[subControl.mark]"
          }
        }), subControl.suffix ? _c("span", [_vm._v(_vm._s(_vm.$t(subControl.suffix)))]) : _vm._e()], 1)]) : subControl.partsType === "multiline" ? [_c("el-input", {
          attrs: {
            type: "textarea",
            placeholder: subControl.promptText,
            disabled: !_vm.echoNodeIsEdit
          },
          model: {
            value: _vm.formData[subControl.mark],
            callback: function ($$v) {
              _vm.$set(_vm.formData, subControl.mark, $$v);
            },
            expression: "formData[subControl.mark]"
          }
        })] : subControl.partsType === "singleChoice" ? [_c("singleChoice", {
          attrs: {
            controlData: subControl,
            formData: _vm.formData,
            isEdit: _vm.echoNodeIsEdit
          }
        })] : subControl.partsType === "multipleChoice" ? [_c("multipleChoice", {
          attrs: {
            controlData: subControl,
            formData: _vm.formData,
            isEdit: _vm.echoNodeIsEdit
          }
        })] : subControl.partsType === "date" ? [_c("dateControl", {
          attrs: {
            controlData: subControl,
            formData: _vm.formData,
            isEdit: _vm.echoNodeIsEdit
          }
        })] : subControl.partsType === "table" ? [_c("table-control", {
          ref: `table${subControl.mark}`,
          refInFor: true,
          attrs: {
            controlData: subControl,
            isEdit: _vm.echoNodeIsEdit
          }
        })] : subControl.partsType === "paragraph" ? _c("div", [_c("paragraphModel", {
          attrs: {
            itemData: subControl,
            isEdit: _vm.echoNodeIsEdit
          }
        })], 1) : subControl.partsType === "dropDown" ? [_c("drop-down-select", {
          attrs: {
            controlConfig: subControl,
            bankData: _vm.bankData,
            countriesData: _vm.countriesData,
            logisticsData: _vm.logisticsData,
            provinceArea: _vm.provinceArea,
            associationInfo: _vm.associationInfo,
            provinceData: _vm.provinceData,
            provinceFirstLevel: _vm.provinceFirstLevel,
            formData: _vm.formData,
            isEdit: _vm.echoNodeIsEdit
          },
          on: {
            showControl: _vm.changeControlShow
          }
        })] : subControl.partsType === "sign" ? [_c("signModel", {
          attrs: {
            itemData: subControl,
            controlMark: _vm.formData[subControl.mark],
            isEdit: _vm.echoNodeIsEdit
          },
          on: {
            "update:controlMark": function ($event) {
              return _vm.$set(_vm.formData, subControl.mark, $event);
            },
            "update:control-mark": function ($event) {
              return _vm.$set(_vm.formData, subControl.mark, $event);
            }
          }
        })] : subControl.partsType === "enclosure" ? [_c("enclosureModel", {
          attrs: {
            formDataArray: subControl,
            isEdit: _vm.echoNodeIsEdit
          }
        })] : _vm._e(), subControl.partsType === "payment" ? [_c("div", {
          staticStyle: {
            display: "flex"
          }
        }, [_c("a-input", {
          style: {
            width: subControl.widthSet
          },
          attrs: {
            placeholder: subControl.promptText,
            disabled: !_vm.echoNodeIsEdit
          },
          model: {
            value: _vm.formData[subControl.mark],
            callback: function ($$v) {
              _vm.$set(_vm.formData, subControl.mark, $$v);
            },
            expression: "formData[subControl.mark]"
          }
        }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e(), subControl.partsType === "estimate" ? [_c("div", {
          staticStyle: {
            display: "flex"
          }
        }, [_c("a-input", {
          style: {
            width: subControl.widthSet
          },
          attrs: {
            placeholder: subControl.promptText,
            disabled: !_vm.echoNodeIsEdit
          },
          model: {
            value: _vm.formData[subControl.mark],
            callback: function ($$v) {
              _vm.$set(_vm.formData, subControl.mark, $$v);
            },
            expression: "formData[subControl.mark]"
          }
        }), _vm._v("   " + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + "   ")], 1)] : _vm._e()], 2)], 1);
      })], 2) : _vm._e()]);
    })], 2);
  }), 0)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };